import { Case } from '../case';
import { BaseObject } from '../base-object';

export abstract class FluidAnalysis extends BaseObject {
  constructor(fluidAnalysis: any, ownerCase: Case) {
    super(fluidAnalysis.id, ownerCase);
  }
}
